(ns hai.ui.utils.polling
  (:require
   [hai.ui.rf-sugar :refer [<s >e defeffect defevent defevent-fx defsub]]))

(defn db-get-interval
  [db poll-id]
  (get-in db [:polling/intervals poll-id]))

(defn db-set-interval
  [db poll-id interval-data]
  (assoc-in db [:polling/intervals poll-id] interval-data))

(defn db-remove-interval
  [db poll-id]
  (update db :polling/intervals dissoc poll-id))

(defsub ::interval
  [db poll-id]
  (db-get-interval db poll-id))

(defsub ::active?
  [poll-id
   interval <- [::interval poll-id]]
  (some? interval))

(defsub ::interval-ms
  [poll-id
   interval <- [::interval poll-id]]
  (:interval-ms interval))

(defevent-fx ::check-stop-condition
  [{:keys [db]} poll-id]
  (when-let [{:keys [table stop-condition-fn]} (db-get-interval db poll-id)]
    (let [rows (get-in db [:collections table :table/rows])]
      (when (and stop-condition-fn (stop-condition-fn rows))
        (println (str "Stop condition met for poll: " poll-id))
        {:fx [[:dispatch [::stop {:id poll-id}]]]}))))

(defeffect ::start-interval
  [{:keys [old-handle id table interval-ms stop-condition-fn]}]
  (when old-handle
    (js/clearInterval old-handle))

  ;; We don't want to wait for the first update
  (>e [:table/resolve table
       {:on-success (fn []
                      (when stop-condition-fn
                        (>e [::check-stop-condition id])))}])

  (let [handle (js/setInterval
                (fn []
                  (println "Polling table...")
                  (>e [:table/resolve table
                       {:on-success (fn []
                                      (when stop-condition-fn
                                        (>e [::check-stop-condition id])))}]))
                interval-ms)]
    (>e [::store-handle {:id id :handle handle}])))

(defevent ::store-handle
  [db {:keys [id handle]}]
  (assoc-in db [:polling/intervals id :handle] handle))

(defevent-fx ::start
  [{:keys [db]} {:keys [id table interval-ms stop-condition-fn]
                 :or {interval-ms 20000
                      stop-condition-fn nil}}]
  (let [existing (db-get-interval db id)
        old-handle (:handle existing)]
    {:db (db-set-interval db id
                          {:table table
                           :interval-ms interval-ms
                           :stop-condition-fn stop-condition-fn})
     ::start-interval {:old-handle old-handle
                       :id id
                       :table table
                       :interval-ms interval-ms
                       :stop-condition-fn stop-condition-fn}}))

(defeffect ::clear-interval
  [{:keys [handle]}]
  (when handle
    (js/clearInterval handle)
    (println "Cleared interval")))

(defevent-fx ::stop
  [{:keys [db]} {:keys [id]}]
  (let [interval-data (db-get-interval db id)
        handle (:handle interval-data)]
    {:db (db-remove-interval db id)
     ::clear-interval {:handle handle}}))
